import { objToURIComponents } from "kwp-core/scripts/utils/helpers";
import lozad from "lozad";

export default () => {
    const pastEventsArchive = document.querySelector(
        ".page-template---template-past-events"
    );

    if (!pastEventsArchive) return;

    const pastEventFilter =
        pastEventsArchive.querySelector("#past-event-filter");

    if (!pastEventFilter) return;

    const yearSelect = pastEventFilter.querySelector("#event_year");

    if (!yearSelect) return;

    const postLoop = pastEventsArchive.querySelector("#post-loop");

    let data = {
        action: "event_request",
        ajax_nonce: event_ajax_obj.nonce,
    };

    const queryString = window.location.search;
    if (queryString.length) {
        const urlParams = new URLSearchParams(queryString);
        if (urlParams.get("year_filter")) {
            yearSelect.value = urlParams.get("year_filter");
        }
    }

    yearSelect.addEventListener("change", () => {
        const queryVars = [];

        data = {
            ...data,
            year_filter: yearSelect.value,
        };

        if (yearSelect.value !== "") {
            queryVars.push(`year_filter=${yearSelect.value}`);
        }

        yearAjax(data, queryVars);
    });

    function yearAjax(ajaxData, ajaxQueryVars) {
        const request = new XMLHttpRequest();

        request.open("POST", event_ajax_obj.ajaxurl, true);
        request.setRequestHeader(
            "Content-Type",
            "application/x-www-form-urlencoded"
        );

        request.onload = function () {
            if (this.status >= 200 && this.status < 400) {
                const response = JSON.parse(this.response);
                postLoop.innerHTML = response.data;

                window.history.pushState({}, "", `?${ajaxQueryVars.join("&")}`);

                // init lozad for images
                const observer = lozad();
                observer.observe();
            } else {
                console.error(this.response);
            }
        };

        request.send(objToURIComponents(ajaxData));
    }
};
